<template>
    <div class="page planRecordPage">
        <!--<h3 class="page-title">培训记录</h3>-->

        <el-form class="page-query" :model="formSearch" :inline="true" size="mini">
            <el-form-item :label="$t('train.name')">
                <el-input v-model="formSearch.name" :placeholder="$t('tip.name')"
                          @keyup.enter.native="getTrainData(1)" clearable></el-input>
            </el-form-item>
            <select-multiple :nameArrays="selectNames"
                             v-on:getTrainTypeVal="getTrainTypeVal"
                             v-on:getTrainModeVal="getTrainModeVal"
                             v-on:getExamFormVal="getExamFormVal">
            </select-multiple>
            <select-multi-orgs v-model="formSearch.orgIds"></select-multi-orgs>
            <el-form-item :label="$t('train.time')">
                <el-date-picker
                    v-model="formSearch.startTime"
                    type="date"
                    :placeholder="$t('tip.startTime')"
                    :picker-options="pickerOptions1"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span>{{$t('c.to')}}</span>
                <el-date-picker
                    v-model="formSearch.endTime"
                    type="date"
                    :placeholder="$t('tip.endTime')"
                    :picker-options="pickerOptions2"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getTrainData(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>

        <div class="page-table">
            <data-tables class="form-table"
                         ref="trainTable"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
            >
                <el-table-column property="name" :label="$t('train.name')" align="center" min-width="180px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.kind" style="float: left;padding-left: 15px;">
                            <i class="nucfont inuc-dingwei" style="color: #999;"></i>
                        </span>
                        {{scope.row.name}}
                    </template>
                </el-table-column>
                <!-- column title -->
                <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                 :width="title.width" :min-width="title.minWidth"
                                 align="center"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                </el-table-column>
                <el-table-column property="percent" :label="$t('train.percent')" align="center" show-overflow-tooltip sortable>
                    <span class="progress" slot-scope="scope">
                        {{scope.row.percent == null ? '-' : (Math.round(scope.row.percent * 10000) / 100 + "%")}}
                    </span>
                </el-table-column>
                <el-table-column property="creatorName" :label="$t('c.creator')" align="center"
                                 show-overflow-tooltip sortable></el-table-column>
                <!-- column buttons -->
                <el-table-column :label="$t('c.operation')" align="center">
                    <div class="btn-cell" slot-scope="scope">
                        <i class="nucfont inuc-preview"
                           @click="previewPlan(scope.row)">
                        </i>
                    </div>
                </el-table-column>
            </data-tables>
        </div>


        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @onClose="onSubpageClose"></router-view>
        </transition>
    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';
    import selectMultiple from '@/components/Selectmultiple.vue'

    export default {
        data() {
            return {
                formSearch: {
                    name: '',
                    types: [0],
                    kinds: [0],
                    forms: [0],
                    orgIds: [],
                    startTime: '',
                    endTime: ''
                },
                tableData: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    height: "auto"
                },
                currentPage: 1,
                titles: [
                    {
                        prop: 'typeName',
                        label: this.$t('train.type')
                    }, {
                        prop: 'formName',
                        label: this.$t('c.examType')
                    }, {
                        prop: 'datetime',
                        label: this.$t('c.date'),
                        width: '190px',
                        sortable: 'custom'
                    }, {
                        prop: 'participants',
                        label: this.$t('train.memberNum'),
                        sortable: 'custom'
                    }
                ],
                selectNames: [{
                    key: "trainType",
                }, {
                    key: "trainMode",
                }, {
                    key: "examForm",
                }],
                selectPlanId: []
            }
        },
        created() {
            this.getTrainData();
        },
        computed: {
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.endTime) return false;
                        return time.getTime() > new Date(that.formSearch.endTime).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.startTime) return false;
                        return time.getTime() < new Date(that.formSearch.startTime).getTime()
                    },
                }
            },
        },
        methods: {
            getTrainData(page){
                if(page) this.currentPage = page;
                let queryData = {...this.formSearch};

                ['types', 'forms'].forEach(v => {
                    if (this.formSearch[v].includes(0)) {
                        delete queryData[v];
                    }
                });

                if (queryData.kinds.indexOf(0) > -1) {
                    delete queryData.kinds
                } else if (queryData.kinds.length && queryData.kinds.indexOf(0) < 0) {
                    queryData.kinds = queryData.kinds.map(v => v-1)
                }

                api.trainingRecord(queryData).then(res=> {
                    let data = res.package;
                    this.tableData = data;
                })
            },
            getTrainTypeVal(data){
                this.formSearch.types = data;
            },
            getTrainModeVal(data) {
                this.formSearch.kinds = data;
            },
            getExamFormVal(data){
                this.formSearch.forms = data;
            },
            previewPlan({id,creatorID,kind}){
                if(kind){
                    this.$router.push({name: 'offlineRecordDetail',params: {planId: id,creator:creatorID}})
                }else{
                    this.$router.push({name: 'planRecordDetail',params: {planId: id,creator:creatorID}})
                }
            },

            onSubpageClose() {
                if (Ticket.get()) this.getTrainData()
            }
        },
        components: {
            selectMultiple
        }
    }
</script>

<style scoped lang="scss">
    .progress {
        display: inline-block;
        width: 60px;
        background-color: #2FC0A1;
        color: #fff;
        text-align: center;
        border-radius: 10px;
    }
</style>
